import { create } from 'zustand';
import { detectPortal, type Portal } from '../lib/portal';

interface PortalState {
  portal: Portal;
}

export const usePortalStore = create<PortalState>(() => ({
  portal: detectPortal(),
}));
